import { http_api } from "../../leadg-api";
import "react-toastify/dist/ReactToastify.css";
const verifyToken = (refreshToken) => {
    return http_api.post("token/verify-token", refreshToken);
};
const confirmEmail = (confirmation) => {
    return http_api.post("account/email-confirmation", confirmation);
};
const forgotPassword = (input) => {
    return http_api.post("account/forgot-password", input);
};
const resetPassword = (input) => {
    return http_api.post("account/reset-password", input);
};
const getRefreshToken = (input) => {
    return http_api.post("token/refreshToken", input);
};
const adUserLogin = (input) => {
    return http_api.post("account/ad-user-login", input);
};
const AuthApi = {
    getRefreshToken,
    confirmEmail,
    forgotPassword,
    resetPassword,
    verifyToken,
    adUserLogin
};
export default AuthApi;
